import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Page title mappings
const pageTitles = {
  '/': 'Tap In',
  '/auth': 'Tap In - Login',
  '/onboarding': 'Tap In - Get Started',
  '/app': 'Tap In - Home',
  '/app/sessions': 'Tap In - Sessions',
  '/app/dms': 'Tap In - Messages',
  '/app/search': 'Tap In - Discover',
  '/app/profile': 'Tap In - Profile',
  '/app/settings': 'Tap In - Settings',
  '/app/dev/playlists': 'Tap In - Playlists',
  '/drivers': 'Tap In - For Drivers',
  '/pitch/uber': 'Tap In - Partners',
  '/pitch/drivers': 'Tap In - Partners',
  '/terms': 'Tap In - Terms of Service',
  '/privacy': 'Tap In - Privacy Policy',
};

// Get page title based on path
const getPageTitle = (pathname) => {
  // Check for exact match first
  if (pageTitles[pathname]) {
    return pageTitles[pathname];
  }
  
  // Check for session detail page
  if (pathname.startsWith('/app/session/')) {
    return 'Tap In - Session';
  }
  
  // Check for DM conversation page
  if (pathname.startsWith('/app/dm/')) {
    return 'Tap In - Chat';
  }
  
  // Check for user profile page
  if (pathname.startsWith('/app/user/')) {
    return 'Tap In - Profile';
  }
  
  // Default fallback
  return 'Tap In';
};

// Hook to update document title based on route
export const usePageTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    const title = getPageTitle(location.pathname);
    document.title = title;
  }, [location.pathname]);
};

// Component version if needed
export const PageTitle = ({ title }) => {
  useEffect(() => {
    document.title = title ? `Tap In - ${title}` : 'Tap In';
    return () => {
      document.title = 'Tap In';
    };
  }, [title]);
  
  return null;
};

export default usePageTitle;
